import { reactive } from 'vue';

export const Modal = reactive({
  alert: async () => {},
  confirm: async () => {},
  dialog: async () => {}
});
